/* Attribution Service */
import './apps/bankrate-cookie'

/* Ensure external links open new window */
import './all-targets-blank'

/* Make parent elements of anchor tags clickable */
import './apps/bankrate-faux-anchor'
